import React from 'react'
import HeroSection from '../components/HeroSection'
import Features from '../components/Features'
import CallToAction from '../components/CallToAction'
import Benefits from '../components/Benefits'
import Testimonials from '../components/Testimonials'
import Partners from '../components/Partners'
import { Helmet } from 'react-helmet'
import FutureEngineersAd from '../components/FutureEngineersAd'
import LatestNews from '../components/LatestNews'
const Home = () => {
  return (
    <div className='bg-white'>
        <Helmet>
          <title>Ikusasa Technology Solutions | Innovative IT Services & Training</title>
          <meta name="description" content="Ikusasa Technology Solutions provides cutting-edge IT services, professional training, and innovative tech solutions for businesses across Africa. Transform your organization with our expert consulting and certified training programs." />
          <meta name="keywords" content="IT solutions, technology services, software development, cybersecurity, cloud computing, IT training, Microsoft training, CompTIA certification, Cisco training, digital transformation" />
          <link rel="canonical" href="https://ikusasatech.com/" />
          <meta property="og:title" content="Ikusasa Technology Solutions | Innovative IT Services & Training" />
          <meta property="og:description" content="Transform your business with our cutting-edge IT services, professional training programs, and innovative technology solutions. Partner with Ikusasa for expert consulting and certified training." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://ikusasatech.com/" />
          <meta property="og:image" content="https://ikusasatech.com/android-chrome-192x192.webp" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Ikusasa Technology Solutions | Innovative IT Services & Training" />
          <meta name="twitter:description" content="Transform your business with our cutting-edge IT services, professional training programs, and innovative technology solutions." />
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Ikusasa Technology Solutions",
                "url": "https://ikusasatech.com",
                "logo": "https://ikusasatech.com/android-chrome-192x192.webp",
                "description": "Leading provider of IT services, training, and innovative technology solutions across Africa.",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "299 Pine Avenue, Ferndale",
                  "addressLocality": "Randburg",
                  "postalCode": "2196",
                  "addressRegion": "Gauteng",
                  "addressCountry": "South Africa"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "contactType": "customer service",
                  "email": "info@ikusasatech.com"
                },
                "sameAs": [
                  "https://www.facebook.com/ikusasatech",
                  "https://www.linkedin.com/company/ikusasa-technology-solutions",
                  "https://twitter.com/ikusasatech"
                ]
              }
            `}
          </script>
        </Helmet>
      <HeroSection/>
      <CallToAction/>
      <LatestNews/>
      <FutureEngineersAd/>
      <Features/>
      <Benefits/>
      <Testimonials/>
      <Partners/>
      
    </div>
  )
}

export default Home
